var alignmentStyle = {"alignLeft":"_-3Ou0","textWrapNowrap":"-A-p4","alignRight":"D5dDg","alignCenter":"Sdpp9","sizeFullWidth":"W2X-7","renderedInTable":"ZG8s-","sizeOriginal":"-xHpA","sizeContent":"isV4m","sizeSmall":"_5vJ-8","sizeSmallCenter":"KBiJv","flex":"kP-PB","LEFT":"i2T3i","CENTER":"Cz5CN","RIGHT":"tsKyy","AUTO":"LRhRI","JUSTIFY":"Jsfyv"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-b67c6cfa.js.map
